import { render, staticRenderFns } from "./CompoundBars.vue?vue&type=template&id=ae04f7ce"
import script from "./CompoundBars.vue?vue&type=script&lang=js"
export * from "./CompoundBars.vue?vue&type=script&lang=js"
import style0 from "./CompoundBars.vue?vue&type=style&index=0&id=ae04f7ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports